import {Icon} from 'src/common/Icon'

type AvailabilityIconProps = {
  available: boolean
}

export const AvailabilityIcon = ({available}: AvailabilityIconProps) => {
  const unavailableColor = {
    circle: 'bg-orange-300',
    icon: 'text-moss-white',
  }

  const availableColor = {
    circle: 'bg-green-default',
    icon: 'text-moss-white',
  }

  return (
    <div
      className={`flex size-5 items-center justify-center rounded-[600px] ${
        available ? availableColor.circle : unavailableColor.circle
      }`}
    >
      <Icon
        name={available ? 'check-mark' : 'cross-bold'}
        className={`${
          available ? `h-[9px] w-[11px] ${availableColor.icon}` : `h-[10px] w-[10px] ${availableColor.icon}`
        }`}
      />
    </div>
  )
}
